import React, { Component } from 'react';
import { Card, CardBody, CardHeader, Row, Col } from 'reactstrap';
import DockerComposePanel from '../components/docker-compose-panel';

class DockerComposePage extends Component {
  render() {
    return (
      <div className="content">
        <Row>
          <Col xs="12">
            <Card>
              <CardHeader>
              </CardHeader>
              <CardBody>
                <DockerComposePanel />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default DockerComposePage;